import React from "react";
import DesktopMacOutlinedIcon from "@mui/icons-material/DesktopMacOutlined";
import PropTypes from "prop-types";
import { SvgIcon } from "@mui/material";
import { Videocam, Stars } from "@mui/icons-material";
import { courseTypes, activityTypes } from "../../constants";
import PolicyIcon from "./PolicyIcon";

function WebinarIcon() {
  return (
    <g>
      <path d="M21 2H3C1.9 2 1 2.9 1 4V18C1 19.1 1.9 20 3 20H21C22.1 20 23 19.1 23 18V4C23 2.9 22.1 2 21 2ZM21 18H3V4H21V18Z" />
      <path d="M6 18V16.1111C6 14.5222 7.35 13.2222 9 13.2222H15C16.65 13.2222 18 14.5222 18 16.1111V18H6ZM12 11.7778C13.665 11.7778 15 10.4922 15 8.88889C15 7.28556 13.665 6 12 6C10.335 6 9 7.28556 9 8.88889C9 10.4922 10.335 11.7778 12 11.7778Z" />
    </g>
  );
}

function IltIcon() {
  return (
    <g>
      <path d="M5.5 22V14.5H4V9C4 7.9 4.9 7 6 7H10C11.1 7 12 7.9 12 9V14.5H10.5V22H5.5ZM8 6C9.11 6 10 5.11 10 4C10 2.89 9.11 2 8 2C6.89 2 6 2.89 6 4C6 5.11 6.89 6 8 6Z" />
      <rect
        x="18.5664"
        y="3.41992"
        width="2.00291"
        height="9.22083"
        transform="rotate(30 18.5664 3.41992)"
      />
    </g>
  );
}

function CourseTypeIcon(props) {
  const { size, color, style, onlineOrIltOnly } = props;
  const iconProps = {
    fontSize: size,
    color,
    style
  };
  function createActivityIcon(activityType) {
    const iltIcon = (
      <SvgIcon {...iconProps}>
        <IltIcon />
      </SvgIcon>
    );

    const activity = activityType.toLowerCase();
    switch (activity) {
      case courseTypes.webinar.toLowerCase():
      case courseTypes.externalWebinar.toLowerCase():
        return onlineOrIltOnly ? (
          iltIcon
        ) : (
          <SvgIcon {...iconProps}>
            <WebinarIcon />
          </SvgIcon>
        );
      case courseTypes.ilt.toLowerCase():
      case courseTypes.inPerson.toLowerCase():
      case courseTypes.instructorLedTraining.toLowerCase():
        return iltIcon;
      case courseTypes.virtual.toLowerCase():
        return onlineOrIltOnly ? iltIcon : <Videocam {...iconProps} />;
      case courseTypes.virtualClassroom.toLowerCase():
        return <Videocam {...iconProps} />;
      case activityTypes.video.toLowerCase():
      case courseTypes.online.toLowerCase():
      case courseTypes.onlineCourse.toLowerCase():
        return <DesktopMacOutlinedIcon {...iconProps} />;
      case courseTypes.policy.toLowerCase():
        return <PolicyIcon {...iconProps} />;
      case courseTypes.other.toLowerCase():
      case courseTypes.policy.toLowerCase():
      case courseTypes.validate.toLowerCase():
        return <Stars {...iconProps} />;
      default:
        return null;
    }
  }

  return props.type ? createActivityIcon(props.type) : null;
}

export default CourseTypeIcon;

CourseTypeIcon.propTypes = {
  type: PropTypes.string,
  color: PropTypes.string
};

CourseTypeIcon.defaultProps = {
  fontSize: "default",
  color: "action"
};
